import { render, staticRenderFns } from "./MainLedgerCard10.vue?vue&type=template&id=e2dd7508"
import script from "./MainLedgerCard10.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard10.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerCard10.vue?vue&type=style&index=0&id=e2dd7508&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports